import { randomUUID } from 'crypto'
import {
  CustomComponentLibrariesGet200Response,
  CustomComponentLibrariesLibraryIdGet200Response,
  CustomComponentLibrariesLibraryIdGet200ResponseData,
  CustomComponentLibrariesLibraryIdRevisionsGet200Response,
  CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response,
  CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200ResponseDataInner,
  CustomComponentLibrary,
  CustomComponentLibraryRevision,
  CustomComponentLibraryRevisionFile,
} from '../retool_client'

const emptyLibraryDefinition: CustomComponentLibrary = {
  id: randomUUID(),
  createdAt: new Date(),
  updatedAt: new Date(),
  description: '',
  label: '',
  name: '',
}

const emptyRevisionDefinition: CustomComponentLibraryRevision = {
  createdAt: new Date(),
  updatedAt: new Date(),
  version: '',
  id: randomUUID(),
  customComponentLibraryId: randomUUID(),
}

const emptyFileDefinition: CustomComponentLibraryRevisionFile = {
  createdAt: new Date(),
  updatedAt: new Date(),
  fileContents: '',
  filepath: '',
}

export const makeGetLibrariesResponse = (
  libraries: Partial<CustomComponentLibrariesLibraryIdGet200ResponseData>[],
): CustomComponentLibrariesGet200Response => {
  return {
    data: libraries.map((libraryPartial) => {
      return {
        id: randomUUID(),
        createdAt: new Date(),
        updatedAt: new Date(),
        description: '',
        label: '',
        name: '',
        ...libraryPartial,
      }
    }),
    hasMore: false,
    nextToken: '',
    success: true,
    totalCount: libraries.length,
  }
}

export const makeGetLibraryResponse = (
  data: Partial<CustomComponentLibrariesLibraryIdGet200ResponseData>,
): CustomComponentLibrariesLibraryIdGet200Response => {
  return {
    data: {
      ...emptyLibraryDefinition,
      ...data,
    },
    success: true,
  }
}

export const makeGetRevisionsResponse = (
  revisions: Partial<CustomComponentLibraryRevision>[],
): CustomComponentLibrariesLibraryIdRevisionsGet200Response => {
  return {
    data: revisions.map((revision) => ({ ...emptyRevisionDefinition, ...revision })),
    hasMore: false,
    nextToken: '',
    success: true,
    totalCount: revisions.length,
  }
}

export const makeGetRevisionFilesResponse = (
  files: Partial<CustomComponentLibraryRevisionFile>[],
): CustomComponentLibrariesLibraryIdRevisionsRevisionIdFilesGet200Response => {
  return {
    data: files.map((file) => ({ ...emptyFileDefinition, ...file })),
    hasMore: false,
    nextToken: '',
    success: true,
    totalCount: files.length,
  }
}
